import { jsx as _jsx } from "react/jsx-runtime";
import { useCommandState } from "@air/cmdk";
import { memo } from "react";
import { SearchCommandBoardListItem } from "~/components/SearchCommand/SearchCommandBoardListItem";
import { SearchCommandGroup } from "~/components/SearchCommand/SearchCommandGroup";
export const SearchCommandBoardList = /*#__PURE__*/ memo((param)=>{
    let { boards, onBoardClick } = param;
    const search = useCommandState((state)=>state.search);
    return /*#__PURE__*/ _jsx(SearchCommandGroup, {
        heading: search ? "Jump to" : "Recent boards",
        children: boards.map((board)=>/*#__PURE__*/ _jsx(SearchCommandBoardListItem, {
                board: board,
                onSelect: onBoardClick
            }, board.id))
    });
});
SearchCommandBoardList.displayName = "SearchCommandBoardList";
